export const ACTIVE_STATES = {
  Yes: 1,
  No: 0,
  Limited: 2,
};
